export default "__VITE_ASSET__DOkMN5jO__"